/** Tooltip copy for legacy dashboard filter labels — presentation only. */
export const LEGACY_DASHBOARD_FIELD_HELP = {
  selectCourse: 'Choose a course to load its analytics and learner data.',
  selectStudent: 'Filter charts and tables to a single learner in the selected course.',
  selectTest: 'Choose a specific test attempt for detailed score and domain analysis.',
  selectCourseAssessments: 'Choose a course to see its assessments and learner performance.',
};
